import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { TipoTaxaEsporadicaComponent } from './tipo-taxa-esporadica.component';
import { TipoTaxaEsporadicaDetalheComponent } from './tipo-taxa-esporadica-detalhe/tipo-taxa-esporadica-detalhe.component';
import { AuthGuard } from 'app/_guards/auth.guard';

const usuariosRoutes: Routes = [
    { path: '', component: TipoTaxaEsporadicaComponent, canActivate: [AuthGuard] },
    // { path: 'detalhe', component: UsuarioDetalheComponent, canActivate: [AuthGuard] },
    // { path: 'detalhe/:id', component: UsuarioDetalheComponent, canActivate: [AuthGuard] }
];

@NgModule({
    imports: [RouterModule.forChild(usuariosRoutes)],
    exports: [RouterModule]
})
export class TipoTaxaEsporadicaRoutingModule {}
